export default __webpack_public_path__ + "static/media/collegebranchLoginpage.1edecbb9.png";